import { parse } from 'query-string';

import {
  SHOW_CASE_AMENDING_BY_IMAGE, LOCATION_CHANGE, TOGGLE_DETAILS,
  TOGGLE_TICK, TOGGLE_PANEL, SET_PAGE, SET_SEARCH_TERM, SET_SCENARIO_KEEP_FOREVER,
  EXPAND_ALL_DETAILS, COLLAPSE_ALL_DETAILS, SELECT_REASON
} from './../actions';

import {
  SCENARIO_STATUS_ORDER_BY_POSITION,
  SCENARIO_STATUS_ORDER_BY_STATUS
} from './../helpers/scenarios.js';

import { isUndefined, values } from 'lodash';
import { commonPageInfo as commonPageHelpers } from '../helpers';

/**
 * This is used as a home for Regression page components' states.
 * Intention here is to help the user apply a setting and keep it across page navigations
 * to where common Regression components are used.
 */
const initialState = {
  viewByImage: true,
  dispatcherJobInfo: {
    jobName: '',
    jobNumber: '',
    numJobs: 25
  },
  activePage: 0,
  expanded: {},
  popup: {},
  searchTerm: '',
  scenariosKeptForever: {},
  panelsOpenStatus: {
    'Failed': false,
    'Error': false,
    'Running': false,
    'Skipped': false,
    'Pending': false,
    'Passed': false,
    'Unknown': false
  },
  selectedFailureReason: '',
  activeTab: commonPageHelpers.DISPATCHER_INFO
};

const pages = [
  '/case-amending',
  '/case-merging',
  '/artifact-regression',
  '/export-regression',
  '/remote-acquire-regression',
  '/diff',
  '/acquisition',
  '/white',
  '/installer',
  '/test-studio',
  '/axiom-ui'];

const commonPageInfo = (state = initialState, action) => {
  switch (action.type) {
    case SELECT_REASON:
      return {
        ...state,
        selectedFailureReason: action.value
      };

    case SHOW_CASE_AMENDING_BY_IMAGE:
      return {
        ...state,
        viewByImage: action.visible
      };

    case TOGGLE_DETAILS:
      return {
        ...state,
        expanded: {
          ...state.expanded,
          [action.item]: state.expanded[action.item] ? false : true
        }
      };

    case EXPAND_ALL_DETAILS:
      const expandList = {};
      for (let i = 0; i < action.scenariosCount; i++) {
        expandList['' + action.order + i] = true;
      }

      return {
        ...state,
        expanded: expandList
      };

    case COLLAPSE_ALL_DETAILS:
      const collapseList = {};
      for (let i = 0; i < action.scenariosCount; i++) {
        collapseList['' + action.order + i] = false;
      }

      return {
        ...state,
        expanded: collapseList
      };

    case TOGGLE_TICK:
      return {
        ...state,
        popup: {
          ...state.popup,
          [action.item]: state.popup[action.item] ? false : true
        }
      };

    case TOGGLE_PANEL:
      return {
        ...state,
        panelsOpenStatus: {
          ...state.panelsOpenStatus,
          [action.item]: state.panelsOpenStatus[action.item] ? false : true
        }
      };

    case SET_PAGE:
      return {
        ...state,
        activePage: action.page - 1
      };

    case SET_SEARCH_TERM:
      return {
        ...state,
        searchTerm: action.text
      };

    case SET_SCENARIO_KEEP_FOREVER:
      return {
        ...state,
        scenariosKeptForever: {
          ...state.scenariosKeptForever,
          [action.title]: action.keep
        }
      };

    case LOCATION_CHANGE:
      if (!action.payload ||
        pages.indexOf(action.payload.pathname) === -1) {
        return state;
      }

      const { nm: jobName, nb: jobNumber, nj: numJobs, tab: tab, ex: expand } =
        parse(action.payload.search);
      const parsedNb = parseInt(jobNumber);
      const parsedNj = parseInt(numJobs);

      const parseEx = {};
      const panelsOpenStatus = { ...state.panelsOpenStatus };
      let page = 0;
      let panel = 1;
      if (expand) {
        for (const key in SCENARIO_STATUS_ORDER_BY_STATUS)
          panelsOpenStatus[key] = false;
        parseEx[expand] = true;
        panel = +expand[0];
        page = +expand.slice(1, expand.length);
        page = (page / 10) | 0;
      }
      if (expand || values(panelsOpenStatus).indexOf(true) === -1)
        panelsOpenStatus[SCENARIO_STATUS_ORDER_BY_POSITION[panel]] = true;
      return {
        ...state,
        dispatcherJobInfo: {
          jobName,
          jobNumber: jobNumber && !isNaN(parsedNb) ? parsedNb : undefined,
          numJobs: numJobs && !isNaN(parsedNj) ? parsedNj : undefined
        },
        expanded: parseEx,
        activePage: page,
        panelsOpenStatus: { ...panelsOpenStatus },
        activeTab: !isUndefined(tab) ? tab : commonPageHelpers.DISPATCHER_INFO
      };

    default:
      return state;
  }
};

export default commonPageInfo;

const getCommonPageInfo = state => state.commonPageInfo;
export const getViewByImage = state => getCommonPageInfo(state).viewByImage;
export const getCommonPageJobInfo = state => getCommonPageInfo(state).dispatcherJobInfo;
export const getExpandedInfo = state => getCommonPageInfo(state).expanded;
export const getPopUpInfo = state => getCommonPageInfo(state).popup;
export const getActivePage = state => getCommonPageInfo(state).activePage;
export const getSearchTerm = state => getCommonPageInfo(state).searchTerm;
export const getScenariosKeptForever = state =>
  getCommonPageInfo(state).scenariosKeptForever;
export const getPanelsOpenStatus = state => getCommonPageInfo(state).panelsOpenStatus;
export const getPanelOpenStatus =
  (state, panel) => getPanelsOpenStatus(state)[panel];
export const getActiveTab = state =>
  getCommonPageInfo(state).activeTab;
export const getSelectedFailureReason = state =>
  getCommonPageInfo(state).selectedFailureReason;
export const dispatchToPageMap = {
  CaseAmendingTests: '/case-amending',
  CaseMergingTests: '/case-merging',
  ArtifactRegression: '/artifact-regression',
  ExportTests: '/export-regression',
  RemoteAcquireRegression: '/remote-acquire-regression',
  DifftoolRegression: '/diff',
  UITests: '/white',
  TestStudio: '/test-studio',
  AxiomUITests: '/axiom-ui'
};


// WEBPACK FOOTER //
// src/reducers/commonPageInfo.js